/**
 * @fileoverview Sentiment badge metadata for contact comms insights.
 *
 * Shared by `ContactCommsTab` (Mail timeline) and `ContactActivityTab`
 * (consolidated Notes & Mail view, MOR-841). Lives in its own module so
 * component files only export components (react-refresh constraint).
 */

export const SENTIMENT_META: Record<
  string,
  { label: string; className: string }
> = {
  positive: { label: "Positive", className: "bg-emerald-50 text-emerald-700" },
  neutral: { label: "Neutral", className: "bg-slate-100 text-slate-600" },
  negative: { label: "Negative", className: "bg-rose-50 text-rose-700" },
  mixed: { label: "Mixed", className: "bg-amber-50 text-amber-700" },
};
